var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "auth" } },
    [
      _c("img", {
        attrs: {
          id: "auth__logo",
          src: "/images/logo/logo.png",
          alt: "Mergers Alliance",
        },
      }),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }